(function () {
  var observerStarted = false;
  var sweepTimer = null;
  var sweepCount = 0;

  function moveSmashDpoOptions() {
    var forms = document.querySelectorAll('form[action*="/cart/add"], form[action="/cart/add"]');
    if (!forms.length) return;

    Array.prototype.forEach.call(forms, function (form) {
      var dpo = form.querySelector('.dpo-container');
      var buybox = form.querySelector('.smash-product-buybox');
      if (!dpo || !buybox) return;

      var anchor = buybox.querySelector('.uploadkit') ||
        buybox.querySelector('.smash-product-gate-message') ||
        buybox.querySelector('.prd-block_actions') ||
        buybox.querySelector('[type="submit"]');

      dpo.classList.add('smash-dpo-options');

      if (anchor && anchor !== dpo && dpo.nextElementSibling !== anchor) {
        buybox.insertBefore(dpo, anchor);
      } else if (!anchor && dpo.parentElement !== buybox) {
        buybox.appendChild(dpo);
      }
    });
  }

  function startObserver() {
    if (observerStarted || !window.MutationObserver || !document.documentElement) return;
    observerStarted = true;
    new MutationObserver(moveSmashDpoOptions).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function startSweeps() {
    moveSmashDpoOptions();
    startObserver();
    if (sweepTimer) return;

    sweepTimer = window.setInterval(function () {
      sweepCount += 1;
      moveSmashDpoOptions();
      if (sweepCount >= 24) {
        window.clearInterval(sweepTimer);
        sweepTimer = null;
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startSweeps);
  } else {
    startSweeps();
  }

  window.addEventListener('load', startSweeps);
})();
